module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-08.c8cc3fbc.svg";